import { IFormFieldProps } from "components/Form/FormField/formfield.interface"
import { IFormAreaProps } from "components/Form/FormArea/formarea.interface"
import { FormikValues } from "formik"
import { IFormGroupProps } from "components/Form/FormGroup/formgroup.interface"

export const areDependenciesMet = (field: IFormFieldProps, area: IFormAreaProps, values: FormikValues) => {
  const dependencies = field.dependencyIds && JSON.parse(field.dependencyIds.toString())
  if (!dependencies) return true
  return area?.formGroups?.findIndex((formGroup: IFormGroupProps) => {
    return formGroup.formFields.find((ff: IFormFieldProps) => {
      return dependencies.every((d: any) => {
        const sameKey = d.formFieldKey === ff.formFieldKey
        if (!sameKey) return false
        const isFalsy = d.value === false && (values[ff.id] === false || values[ff.id] === "false" || !values[ff.id])
        const isTruthy = d.value === true && (values[ff.id] === true || values[ff.id] === "true")
        return isFalsy || isTruthy || values[ff.id] === d.value
      })
    })
  }) !== -1
}